import React, { PureComponent } from 'react'
import { BrowserRouter, Route, Redirect, Link, Switch } from 'react-router-dom'
import { Dimmer, Loader } from 'semantic-ui-react'
import Home from '../../pages/Home'
import GettingStarted from '../../pages/GettingStarted'
import ApiLimit from '../../pages/ApiLimit'
import Dashboard from '../../pages/Dashboard'
import Apis from '../../pages/Apis'
import ApiDetails from '../../pages/ApiDetails'
import AlertPopup from '../../components/AlertPopup'
import { init, isAuthenticated } from '../../services/self'
import { apiGatewayClient } from '../../services/api'
import './App.css'
import '../rex.css'

const NoMatch = () => <h2>Page not found</h2>
class MatchWhenAuthorized extends PureComponent { // eslint-disable-line
    constructor(props) {
        super(props)

        const apiGatewayClientInterval = window.setInterval(() => {
            if (apiGatewayClient) {
                window.clearInterval(apiGatewayClientInterval)
                this.setState({ apiGatewayClient })
            }
        }, 100)

        this.state = { apiGatewayClient, apiGatewayClientInterval }
    }

    componentWillUnmount() {
        if (this.state.apiGatewayClientInterval) window.clearInterval(this.state.apiGatewayClientInterval)
    }

    render() {
        const { component: Component, ...rest } = this.props

        return <Route {...rest} render={props => {
            if (!isAuthenticated()) return <Redirect to={{ pathname: '/', state: { from: props.location } }} />

            return this.state.apiGatewayClient ? <Component {...props} /> : (<Dimmer active>
                <Loader content='Loading' />
            </Dimmer>)
        }} />
    }
}

export default class App extends PureComponent {
    constructor() {
        super()
        init()

        // We are using an S3 redirect rule to prefix the url path with #!
        // This then converts it back to a URL path for React routing
        // NOTE: For local development, you will get a Page Not Found when refreshing the Swagger UI page when it has a #!
        const hashRoute = window.location.hash.substring(2)
        window.history.pushState({}, 'home page', hashRoute)
    }

    render() {
        return (
            <BrowserRouter>
                <div className="App">
                    <div className="ui container">
                        <div className="App-header">
                            <Link to="/"><img src="../../nav_logo.png" className="App-logo" alt="logo" /></Link>
                            <h1>Welcome to our Developer Portal</h1>
                        </div>
                        <section className="App-wrap">
                            <section className="App-intro">
                                <AlertPopup />
                                <Switch>
                                    <Route exact path="/" component={Home} />
                                    <Route path="/api-limit" component={ApiLimit} />
                                    <Route path="/getting-started" component={GettingStarted} />
                                    <Route path="/dashboard" component={Dashboard} />
                                    <Route exact path="/apis" component={Apis} />
                                    <Route path="/apis/:apiId" component={ApiDetails} />
                                    <Route component={NoMatch} />
                                </Switch>
                            </section>
                        </section>
                    </div>
                </div>
            </BrowserRouter>
        )
        /*
    
    
         */
    }
}



// WEBPACK FOOTER //
// ./src/components/App/index.js